<div class="padding flex column fix-width">
	<b>Pickup products</b>
	<img class="pickup-image margin-bottom-small margin-top-small" src="assets/pickup.png" alt="Pickup ready" />

	<div class="bg-orange padding-small margin-bottom-small">
		<i class="fa-solid fa-hourglass margin-right-smallest"></i>
		Order is ready for pickup!
	</div>

	<div>The photographer can pick up the product from the warehouse and start shooting.</div>

	<div class="flex column end full-width margin-top">
		<div class="flex center">
			<button (click)="close()" class="stroked">
				<i class="fa-solid fa-check"></i>
				Close
			</button>
		</div>
	</div>
</div>
